import { gql } from "@apollo/client";

import RunActionFieldsFragment from "components/Run/elements/ActionButtons/ActionFragment";

export const GET_RUN = gql`
  query GetRun(
    $stackId: ID!
    $runId: ID!
    $includeAnsibleHosts: Boolean!
    $ansibleHostsInput: RunOrStackArgs
    $includeObservabilityStatus: Boolean!
  ) {
    stack(id: $stackId) {
      __typename
      id
      blocker {
        id
        state
        type
      }
      isDisabled
      managesStateFile
      run(id: $runId) {
        ...RunActionFieldsFragment
        finished
        priorityPreset
        retryBlocker
        branch
        promoteBlocker
        command
        comments {
          __typename
          body
          createdAt
          username
        }
        createdAt
        commit {
          authorLogin
          authorName
          hash
          timestamp
          url
        }
        commits
        delta {
          addCount
          changeCount
          deleteCount
          resources
          importCount
          forgetCount
          moveCount
          ignoreCount
          okCount
          rescueCount
          skipCount
          unreachableCount
          failedCount
        }
        dependsOn {
          id
          state
          runId
          runUpdatedAt
          stackId
          stackName
        }
        triggeredRuns {
          id
          state
          runId
          runUpdatedAt
          stackId
          stackName
        }
        driftDetection
        expired
        externalDependencies {
          id
          status
          completedAt
          createdAt
        }
        isMostRecent
        needsApproval
        observabilityStatus @include(if: $includeObservabilityStatus) {
          metrics
          traces
        }
        policyReceipts {
          id
          createdAt
          engineType
          flags
          policyName
          policyType
          policySlug
          policyDeleted
          outcome
          sampled
          sampleExpired
        }
        reviews {
          id
          author
          decision
          note
          timestamp
        }
        runtimeConfig {
          afterApply
          afterDestroy
          afterInit
          afterPerform
          afterPlan
          afterRun
          beforeApply
          beforeDestroy
          beforeInit
          beforePerform
          beforePlan
          projectRoot
          terraform {
            version
            workflowTool
          }
          terragrunt {
            terraformVersion
            terragruntVersion
            tool
          }
          opentofu {
            enableCPUProfiling
          }
          yaml
        }
        customRuntimeConfig {
          yaml
        }
        forceApplyMode
        planPoliciesOutcomes {
          id
          deny
          warn
          info
          createdAt
        }
        supportsDetailedResources
        title
        triggeredBy
        type
        next {
          id
        }
        previous {
          id
        }
      }
      workerPool {
        id
        name
        busyWorkers
        pendingRuns
        workers {
          id
          busy
          drained
        }
      }
    }
    ansibleHosts(input: $ansibleHostsInput) @include(if: $includeAnsibleHosts) {
      id
    }
  }
  ${RunActionFieldsFragment}
`;

export const GET_NEXT_RUN_INFO = gql`
  query GetNextRunInfo($stackId: ID!, $runId: ID!) {
    stack(id: $stackId) {
      id
      run(id: $runId) {
        id
        type
        next {
          id
        }
      }
    }
  }
`;
